import { useEffect } from "react";
import { useNavigate } from "react-router";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { findGetParameter } from "../../components/utilities/UtilityFunctions";

export default function LREventCalendar() {
  let _search = window.location.search || "";
  let _circuitId = findGetParameter("circuitId");
  if (!_circuitId) {
    _circuitId = findGetParameter("league");
  }
  const navigate = useNavigate();
  useEffect(() => {
    navigate(_circuitId ? `/calendar/${_circuitId}${_search}` : "/");
    // eslint-disable-next-line
  }, []);
  return <ModalLoadingFull />;
}
